<div class="visible-lg">
  <div class="flex-container">
    <div class="bmw-bulletin-container flex">
      <div class="flex-container space-between grow">
        <div class="bmw-bulletin-title flex">
          Full Report
        </div>
        <div class="flex">
            <div class="cms-modal-select-make-checkbox">
              <label class="container">BMW
                <input type="radio" name="bmwradio" (change)='getFullReportByMakeName()' value="BMW" [(ngModel)]='makeName'>
                <span class="checkmark"></span>
              </label>
              <label class="container">MINI
                <input type="radio" name="miniradio" (change)='getFullReportByMakeName()' value="MINI" [(ngModel)]='makeName'>
                <span class="checkmark"></span>
              </label>
              <label class="container">MOTORRAD
                <input type="radio" name="motorradradio" (change)='getFullReportByMakeName()' value="MOTORRAD" [(ngModel)]='makeName'>
                <span class="checkmark"></span>
              </label>
              <label class="container">ROLLSROYCE
                <input type="radio" name="rollsroyceradio" (change)='getFullReportByMakeName()' value="ROLLSROYCE" [(ngModel)]='makeName'>
                <span class="checkmark"></span>
              </label>
            </div>
        </div>
        <div>
          <button type='submit' (click)='downloadExcel()' class="bmw-submit-button" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
           style="padding:7px;margin-top:35px;margin-bottom:10px">Save Report</button>
        </div>
      </div>
                 
      <div class="bmw-users-content" #scrollingBlock>
          <div class="flex-container" style="padding-top: 10px;">
            <div class="align-right flex-20">
              <input type="text" size=15 style="height:34px;font-size:16px;border-radius:0px" placeholder="prior days"
                name="priorDays" [(ngModel)]='priorDays'>
              <button [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' style="height: 34px;" class="pointer bmw-button-primary lg-primary"
          (click)='getPriorDaysReport()'>Submit</button>
            </div>
            <div class="flex-1"></div>
            <label>Please enter number of prior days which to compile report(leave empty to include ALL data)</label>
            <div class="flex-10"></div>
            <div class="align-right flex-20">
              <form class="input-group" name="findRatingForm" style="width: 80%;">
                <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Rating"
                  name="findRating" [(ngModel)]="searchRating">
                <div class="input-group-btn">
                  <button [ngClass]="{'mini-button-style' : (APP_SETTINGS.isMINI === 'true'),'rr-button-style' :(APP_SETTINGS.isRollsRoyce === 'true'),'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}"
                    class="btn btn-default" type="submit">
                    <i class="glyphicon glyphicon-search"></i></button>
                </div>
              </form>
            </div>
            <div class="flex-2"></div>
        </div>
        <div class="bmw-user-header flex-container flex-align-center">
          <div class="flex-9">
            <label>Bulletin Number</label>
            <i class="fa pointer" (click)="sortByProperty('bulletinNumber')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'bulletinNumber', 'fa-sort-asc bmw-sort-control-asc': (column == 'bulletinNumber' && isDesc), 'fa-sort-desc': (column == 'bulletinNumber' && !isDesc) }"
            aria-hidden="true"> </i>
          </div>
          <div class="flex-1"></div>
          <div class="flex-18">
            <label>Subject</label>
            <i class="fa pointer" (click)="sortByProperty('subject')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'subject', 'fa-sort-asc bmw-sort-control-asc': (column == 'subject' && isDesc), 'fa-sort-desc': (column == 'subject' && !isDesc) }"
            aria-hidden="true"> </i>
          </div>
          <div class="flex-1"></div>
          <div class="flex-4">
            <label>Rating</label>
            <i class="fa pointer" (click)="sortByProperty('rating')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'rating', 'fa-sort-asc bmw-sort-control-asc': (column == 'rating' && isDesc), 'fa-sort-desc': (column == 'rating' && !isDesc) }"
            aria-hidden="true"> </i>
          </div>
          <div class="flex-1"></div>
          <div class="flex-15">
            <label>Comment</label>
            <i class="fa pointer" (click)="sortByProperty('comment')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'comment', 'fa-sort-asc bmw-sort-control-asc': (column == 'comment' && isDesc), 'fa-sort-desc': (column == 'comment' && !isDesc) }"
            aria-hidden="true"> </i>
          </div>
          <div class="flex-1"></div>
          <div class="flex-10">
            <label>Last Name</label>
            <i class="fa pointer" (click)="sortByProperty('lastName')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'lastName', 'fa-sort-asc bmw-sort-control-asc': (column == 'lastName' && isDesc), 'fa-sort-desc': (column == 'lastName' && !isDesc) }"
            aria-hidden="true"> </i>
          </div>
          <div class="flex-1"></div>
          <div class="flex-10">
            <label>First Name</label>
            <i class="fa pointer" (click)="sortByProperty('firstName')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'firstName', 'fa-sort-asc bmw-sort-control-asc': (column == 'firstName' && isDesc), 'fa-sort-desc': (column == 'firstName' && !isDesc) }"
            aria-hidden="true"> </i>
          </div>
          <div class="flex-1"></div>
          <div class="flex-12">
            <label>Email</label>
            <i class="fa pointer" (click)="sortByProperty('firstName')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'firstName', 'fa-sort-asc bmw-sort-control-asc': (column == 'firstName' && isDesc), 'fa-sort-desc': (column == 'firstName' && !isDesc) }"
            aria-hidden="true"> </i>
          </div>
          <div class="flex-1"></div>
          <div class="flex-10">
            <label>Phone</label>
            <i class="fa pointer" (click)="sortByProperty('firstName')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'firstName', 'fa-sort-asc bmw-sort-control-asc': (column == 'firstName' && isDesc), 'fa-sort-desc': (column == 'firstName' && !isDesc) }"
            aria-hidden="true"> </i>
          </div>
          <div class="flex-1"></div>
          <div class="flex-6">
            <label>Timestamp</label>
            <i class="fa pointer" (click)="sortByProperty('timeStamp')" style="margin-left:5px" [ngClass]="{'fa-sort': column != 'timeStamp', 'fa-sort-asc bmw-sort-control-asc': (column == 'timeStamp' && isDesc), 'fa-sort-desc': (column == 'timeStamp' && !isDesc) }"
            aria-hidden="true"> </i>
          </div>
        </div>
        <div *ngIf='errorMessage?.length > 0 || fullReportData?.length == 0' class="alert alert-warning align-center">
          <div *ngIf='errorMessage?.length > 0; else noData'><h5 style="color: #ff0000">{{errorMessage}}</h5></div> 
          <ng-template #noData>No Reports Found</ng-template>
        </div>
        <div class="bmw-user flex-container flex-align-center" 
         *ngFor='let report of fullReportData | searchFilter: "bulletinNumber,subject": searchRating |  sortBy: {property: column, direction: direction} |
         paginate: { itemsPerPage: 20, currentPage: p }'>
          <div class="flex-9" style="word-wrap: break-word">
            {{report?.bulletinNumber}}
          </div>
          <div class="flex-1"></div>
          <div class="flex-18" style="word-wrap: break-word">
            {{report?.subject}}
          </div>
          <div class="flex-1"></div>
          <div class="flex-4" style="word-wrap: break-word">
            <div>{{report?.rating}}</div>
          </div>
          <div class="flex-1"></div>
          <div class="flex-15" style="word-wrap: break-word">
            {{report?.comment}}
          </div>
          <div class="flex-1"></div>
          <div class="flex-10" style="word-wrap: break-word">
            {{report?.lastName}}
          </div>
          <div class="flex-1"></div>
          <div class="flex-10" style="word-wrap: break-word">
            {{report?.firstName}}
          </div>
          <div class="flex-1"></div>
          <div class="flex-12" style="word-break: break-all">
            {{report?.email}}
          </div>
          <div class="flex-1"></div>
          <div class="flex-10" style="word-wrap: break-word">
            {{report?.businessPhone}}
          </div>
          <div class="flex-1"></div>
          <div class="flex-6" style="word-wrap: break-word">
            {{report?.timeStamp | date: 'shortDate'}}
          </div>
        </div>
      </div>
      <pagination-controls (pageChange)="p = $event;pageNumChange( $event)"></pagination-controls>
    </div>
  </div>
</div>
